// 🪶 Chatouiller — collecte : des plumes sont éparpillées dans le labyrinthe. L'adversaire attend
// au bout du chemin, mais il ne se laisse chatouiller qu'une fois toutes les plumes ramassées.
import { baseState, countTick, distanceMap, finish, pickCell, sameCell, timeGain } from './common.js';

/** Nombre de plumes selon la longueur du chemin : 2 sur les petits labyrinthes, 5 au plus. */
export const featherCount = (length) => Math.min(5, 2 + Math.floor(length / 12));

/**
 * Plumes bien réparties : la première au hasard, chacune des suivantes le plus loin possible
 * (en ligne droite) du départ, de l'adversaire et des plumes déjà posées.
 */
export function scatterFeathers(grid, start, rival, count, random) {
  const dist = distanceMap(grid, start);
  const candidates = [];
  dist.forEach((row, y) => row.forEach((d, x) => {
    if (d >= 2 && !sameCell({ x, y }, rival)) candidates.push({ x, y });
  }));
  const placed = [];
  const anchors = [start, rival];
  while (placed.length < count && candidates.length > 0) {
    let cell;
    if (placed.length === 0) {
      cell = pickCell(candidates, random);
    } else {
      const spread = (c) => Math.min(...[...anchors, ...placed].map((a) => Math.abs(a.x - c.x) + Math.abs(a.y - c.y)));
      const best = Math.max(...candidates.map(spread));
      cell = pickCell(candidates.filter((c) => spread(c) === best), random);
    }
    placed.push(cell);
    candidates.splice(candidates.findIndex((c) => sameCell(c, cell)), 1);
  }
  return placed;
}

export const tickle = {
  id: 'tickle',
  create(ctx) {
    const length = Math.max(1, ctx.path.length - 1);
    const rival = ctx.path.at(-1);
    const count = featherCount(length);
    return baseState(ctx, {
      rival,
      budget: Math.max(10, Math.ceil((count + 1) * length * 1.5)),
      idleTicks: 3,
      items: scatterFeathers(ctx.grid, ctx.player, rival, count, ctx.random ?? Math.random),
    });
  },
  tick: (state) => countTick(state),
  enter(state, { player }) {
    const items = state.items.filter((item) => !sameCell(item, player));
    const next = items.length === state.items.length ? state : { ...state, items };
    return items.length === 0 && sameCell(next.rival, player) ? finish(next, 'win') : next;
  },
  gain: (state) => timeGain(state.fullGain, state.ticks, state.budget),
  isIdle: (state) => state.ticks >= state.idleTicks,
  hints: (state) => [
    ...state.items.slice(0, 1).map((cell) => ({ key: 'scenario.tickle.hint.goal', cell })),
    { key: 'scenario.tickle.hint.rival', cell: state.rival },
  ],
};
